<style lang="scss" scoped>
.sync-run {
	&__description {
		padding-top: 0;
		margin-top: 0;
		padding-bottom: 15px;
	}
	&__row {
		margin-bottom: 20px;
	}
	&__table {
		td {
			&:last-of-type {
				text-align: left;
				padding-right: 18px;
			}
		}
		tr:last-of-type td {
			border-bottom: none;
		}
	}
	&__sub-header {
		font-size: 20px;
	}
	&__number {
		font-weight: 600;
		font-size: 20px;
		margin-right: 12px;
		&.--additions {
			color: rgb(47, 169, 91);
		}
		&.--modifications {
			color: rgb(39, 135, 239);
		}
		&.--deletions {
			color: rgb(255, 186, 52);
		}
		&.--errors {
			color: rgb(240, 58, 56);
		}
	}
	&__show-more {
		margin-left: auto;
	}
	&__panel {
		@include main-panel-padded;
	}
	&__container {
		@include container;
	}
	&__header {
		@include flex-center;
		&__actions {
			margin-left: auto;
		}
		&__icon {
			position: relative;
			top: 2px;
			margin-right: 10px;
		}
	}
	&__console {
		background: #21252b;
		border-radius: 10px;
		margin-top: 20px;
		padding: 20px;
		&__container {
			height: 600px;
			overflow: scroll;
		}
		&__row {
			line-height: 26px;
			color: darken(white, 20);
			@include flex-center;
			&__date {
				margin-right: 10px;
				color: #cc99cd;
			}
			&__action {
				margin-right: 10px;
			}
			&__name {
				margin-right: 10px;
				font-weight: 600;
				color: #f08d49;
			}
			&__id {
				font-weight: 200;
				color: grey;
			}
			&__help i.el-icon-question {
				color: orange;
				margin-left: 5px;
			}
		}
	}
	&__post_sync_message {
		margin: 0px 0px 20px;
	}
}
</style>

<template lang="pug">
.sync-run 
	app-header
		.sync-run__header(slot="header")
			h1 
				template(v-if="isRunning") 
					i.el-icon-loading.sync-run__header__icon
					| Sync running
				template(v-else-if="hasFinished") Sync finished
				template(v-else-if="!hasSchoolConnection") Sync cancelled
				template(v-else) Sync starting
			.sync-run__header__actions
				el-button(plain, @click="goToDirectory") Go back to directory
				el-button(type="danger", @click="cancelSync", :disabled="hasCancelled || hasFinished") Cancel sync
	.sync-run__container
		.sync-run__panel
			div.sync-run__post_sync_message(v-if="hasFinished && results.Errors.rows.length")
				el-alert(title="This sync finished with errors - scroll down to view the Error Report for details.", type="error", show-icon, :closable="false")
			.sync-run__progess
				el-progress(:percentage="syncPercent", :color="syncColor", :text-inside="true", :stroke-width="18", text-color="#fff")
			.sync-run__console
				.sync-run__console__container(ref="scroll")
					.sync-run__console__row(v-for="log in logsOrdered")
						.sync-run__console__row__date {{ log.created_at | date_and_time }}
						.sync-run__console__row__action {{ log.type | unslug | past_tense | capitalize }}
						.sync-run__console__row__name {{ log.name }}
						.sync-run__console__row__id(v-show="log.type === 'error'") [{{ log.id }}]
						.sync-run__console__row__help(v-show="log.message && log.message.includes('Precondition check failed')")
							a(href="https://edusync.zendesk.com/hc/en-gb/articles/13849027211805--Precondition-check-failed-error-when-provisioning-Classroom-memberships-Google", target="_blank")
								i.el-icon-question
		.sync-run__panel(v-if="type === 'sync_finish'")
			p.sync-run__description Error Report
			el-card.sync-run__row(
				v-for="(data, key) of { errors: results.Errors }"
			)
				div(slot="header")
					.d-flex.align-items-center
						span.sync-run__number(:class="`--${key}`") {{ data.rows.length }}
						span.sync-run__sub-header {{ key }}
						el-button.sync-run__show-more(v-show="data.rows.length", @click="data.show = !data.show") {{ data.show ? 'hide' : 'show' }}
				div(v-show="data.show")
					el-collapse
						el-collapse-item
							template(slot="title") 
								el-tag.sync-run__tag(size="mini") {{ data.rows.length }}

							table.table.sync-run__table
								thead
									th Name
									th(v-if="key === 'errors'") Error Code
									th Message
								tbody
									tr(v-for="row in data.rows")
										td {{ row.name }}
										td(v-if="key === 'errors'") {{ row.code }}
										td {{ row.message || row.type }}
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
export default {
	mounted() {
		let autoScrollEnabled = true;

		// Disable autoscroll once the user has manually scrolled
		this.$refs.scroll.addEventListener("scroll", () => {
			var element = this.$refs.scroll;
			if (element.scrollTop >= element.scrollHeight - 600) {
				autoScrollEnabled = true;
			} else {
				autoScrollEnabled = false;
			}
		});

		// Autoscroll to most recent activity
		const updateScroll = () => {
			var element = this.$refs.scroll;
			if (element && autoScrollEnabled) {
				element.scrollTop = element.scrollHeight;
			}
		};

		setInterval(updateScroll, 1000);
	},

	computed: {
		workLength() {
			if (this.work) {
				return Math.floor(this.work.TotalQty);
			}
			return 0;
		},
		syncPercent() {
			this.$root.$emit("directory-reload-required");

			if (this.hasFinished || !this.hasSchoolConnection) {
				return 100;
			} else if (this.itemCount && this.workLength) {
				return Math.floor((this.itemCount / this.workLength) * 100);
			} else {
				return 0;
			}
		},
		syncColor() {
			return this.hasFinished || !this.hasSchoolConnection ? "#34a853" : "#4285f4";
		},
		logsOrdered() {
			return _.sortBy(this.logs, "created_at");
		},
		hasFinished() {
			return !_.isEmpty(_.find(this.logs, { type: "sync_finish" }));
		},
		hasStarted() {
			return this.itemCount > 0;
		},
		isRunning() {
			return this.hasStarted == true && this.hasFinished == false && this.hasSchoolConnection == true;
		},
		hasSchoolConnection() {
			return _.isEmpty(_.find(this.logs, (log) => /School has no active connection/.test(log.name)));
		}
	},

	methods: {
		goToDirectory() {
			this.$router.push({ name: "directory" });
		},
		async cancelSync() {
			this.hasCancelled = true;
			await this.$apollo
				.mutate({
					mutation: gql`
						mutation CancelSyncWork($uuid: String!) {
							CancelSyncWork(uuid: $uuid)
						}
					`,
					variables: {
						uuid: this.$route.params.uuid,
					},
				});
		},
	},

	data() {
		return {
			results: {
				Additions: {
					rows: [],
					show: false,
				},
				// Modifications: { rows: [], show: false },
				// Deletions: { rows: [], show: false },
				Errors: { rows: [], show: false },
				// Running: false,
				// Ready: false,
				// Failed: false,
			},
			itemCount: 0,
			latestId: "",
			logs: [],
			type: "",
			end: false,
			hasCancelled: false,
		};
	},
	updated() {
		if (this.type === "sync_finish" && this.end === false) {
			if (this.logs) {
				this.logs.map((log) => {
					if (log.type === "error") {
						this.results.Errors.rows.push(log);
					} else if (log.type.includes("create")) {
						this.results.Additions.rows.push(log);
					}
				});
			}
			this.end = true;
		}
	},

	apollo: {
		work: {
			query: gql`
				query GetSync($uuid: String!) {
					Sync(uuid: $uuid) {
						id
						Additions {
							id
						}
						Modifications {
							id
						}
						Deletions {
							id
						}
						TotalQty
					}
				}
			`,
			update: (r) => r.Sync,
			variables() {
				return {
					uuid: this.$route.params.uuid,
				};
			},
		},

		logs: {
			query: gql`
				query GetActivities($uuid: String!, $latestId: String!) {
					Activities(uuid: $uuid, latestId: $latestId) {
						id
						type
						name
						message
						code
						created_at
					}
				}
			`,
			pollInterval: 3000,
			fetchPolicy: "no-cache",
			update(r) {
				if (r.Activities && r.Activities.length) {
					// Store id of the latest activity entry retrieved
					this.latestId = r.Activities[r.Activities.length - 1].id;

					// Update item count
					this.itemCount += r.Activities.length;

					// Cap total results
					const activityLimit = 5000;
					let activity = _.concat(this.logs, r.Activities);
					if (activity.length > activityLimit) {
						activity = _.drop(activity, activity.length - activityLimit);
					}
					this.type = activity[activity.length - 1].type;
					return activity;
				} else {
					return this.logs;
				}
			},
			variables() {
				return {
					uuid: this.$route.params.uuid,
					latestId: this.latestId,
				};
			},
			skip() {
				return this.hasFinished || !this.hasSchoolConnection;
			},
		},
	},
};
</script>
